import React, { useState, useEffect } from "react";
import { GoogleChartWrapperChartType } from "react-google-charts";
import { getData } from "../../../CommonElements/Functions/PostGetFun";
import { API } from "../../../api/API";
import { Chart } from "react-google-charts";
import { Card, CardBody, Col } from "reactstrap";
import CardHeaderSpan from "../../../Utils/CommonComponents/CardHeaderSpan";

const ActiveVacantTerritories: React.FC = () => {
  const [activeVacantData, setActiveVacantData] = useState<any>({});
  console.log(activeVacantData);

  useEffect(() => {
    const getactiveVacantTerritories = async () => {
      const serverUrl = localStorage.getItem("serverUrl");
      if (!serverUrl) {
        console.error("Server URL not found in localStorage.");
        return [];
      }

      const url = `${serverUrl}${API.activeVacantTerritories}`;
      console.log("============ActiveVacantTerritories============", url);

      try {
        const { status, data } = await getData(url, true);

        if (status === 200 && data.data) {
          setActiveVacantData(data.data);
        } else {
          console.error("Failed to fetch effort report data");
        }
      } catch (error) {
        console.error("Error fetching effort report:", error);
      }
    };
    getactiveVacantTerritories();
  }, []);

  interface ChartConfig {
    width: string;
    height: string;
    chartType: GoogleChartWrapperChartType;
    data: (string | number)[][];
    options: any;
  }

  const pieChart4: ChartConfig = {
    width: "100%",
    height: "300px",
    chartType: "PieChart",
    data: [
      ["Task", "Count"],

      [
        "Active Territories",
        Number(activeVacantData?.totalActiveTerritories) || 0,
      ],
      [
        "Vacant Territories",
        Number(activeVacantData?.totalVacantTerritories) || 0,
      ],
    ],
    options: {
      title:` Total Territories : ${Number(activeVacantData?.totalTerritories) || 0}`,
      is3D: true,
      colors: ["#307EF3", "#EBA31D"],
      legend: {
        position: "bottom", 
        alignment: "center", 
        textStyle: {
          fontSize: 14,
        },
      },
    },
  };

  return (
    <Col xl="6" lg="6" md="12" sm="12">
      <Card>
        <CardHeaderSpan
          headingClassName="pb-0"
          heading={ "Active Vacant Territories"}
        />
        <CardBody className={`chart-block `}>
          <div>
            <Chart
              width={pieChart4?.width}
              height={pieChart4?.height}
              chartType={pieChart4.chartType}
              loader={<div>{"Loading Chart"}</div>}
              data={pieChart4?.data}
              options={pieChart4?.options}
            />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ActiveVacantTerritories;
